export default {

    buildQuery: function (filter) {

        if (filter) {

            let query = [];

            _.forOwn(filter, function (value, key) {
                if (value) {
                    query.push(key + "=" + encodeURIComponent(value));
                }
            });

            if (query.length > 0) {
                return "?" + query.join("&");
            }
        }

        return null;
    },

    resolveCurrentDomain() {
        return document.location.origin
    },

    localStorageSetItem(label, obj) {
        window.localStorage.setItem(label, JSON.stringify(obj))
    },

    localStorageGetItem(label) {
        const string = window.localStorage.getItem(label)
        return JSON.parse(string)
    },

    buildAppErrorMessage(errorsParam) {

        let errors = [];

        let i;
        for (i in errorsParam) {
            let error = errorsParam[i];
            errors.push(error.pt);
        }

        return errors;
    },

    buildErrorMessage(errorsParam) {

        let errors = [];

        let i;
        for (i in errorsParam) {
            let error = errorsParam[i];
            errors[error.field] = error;
        }

        return errors
    },

    hasRole(roles, role) {

        if (role) {

            let authority = role.substring(role.length - 7, role.length);
            authority = 'ROLE_' + authority;

            if (roles) {
                if (roles.indexOf(authority) >= 0) {
                    return true
                }
            }
        }
        return false
    },

    resolveLabel(item) {
        return item.labelPt;
    }
}



// WEBPACK FOOTER //
// ./src/services/UtilsService.js